import Control from "sap/ui/core/Control";
import { BaseLogFormatter } from "./BaseLogFormatter";
import {
  FormatDateTime,
  FormatPrice,
} from "akademika/akamont/utils/FormatUtil";

export class ContractLogFormatter extends BaseLogFormatter {
  generateControlForValue(
    value: string | null | undefined,
    fieldName: string
  ): Control {
    switch (fieldName) {
      case "CreationDate":
        return this.generateTextControl(FormatDateTime(value));
      case "Price":
        return this.generateTextControl(FormatPrice(value));
      case "Distance":
        return this.generateTextControl(value && value + " km");
      case "IsDeleted": {
        const translatedValue = this.getTextForBooleanValue(value);
        return this.generateTextControl(translatedValue);
      }
      default:
        return this.generateTextControl(value);
    }
  }
}
